import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Stack, Typography, TextField } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import { formatDate, formatDateTime } from '../../../../../../services/functions';
import { getPeriodsAction, getActivitiesAction, getPackagesAction } from '../../../../../../services/request';
import { AutocompleteImpl } from '../../../../../../components/AutoCompleteImpl';
import { SmallFormDateField } from '../../../../../../components/small-fields/SmallFormDateField';
import { AutocompleteImplSpecial } from '../../../../../../components/AutoCompleteSpecial';
import { DynamicMultiFieldCard } from '../ReservationDataTab/DynamicMultiFieldCard';

const ZSOrderDetailsForm = ({ formik }) => {
  const { order } = useSelector(state => state.orderData);
  const { seasonIdentifier, seasonYear } = useSelector(state => state.app);

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
      <Stack justifyContent="space-around" spacing={1} sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Numer Zamówienia</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            error={formik.errors.identifier && formik.touched.identifier}
            name="identifier"
            placeholder="numer zamówienia"
            value={formik.values.identifier}
            onChange={formik.handleChange}
            helperText={formik.errors.identifier}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Data zamówienia</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SmallFormDateField
              sx={{ flex: '1 1 70%' }}
              name="created_at"
              inputFormat="yyyy-MM-dd hh:mm"
              mask="____-__-__ __:__"
              label="data zamówienia"
              value={formik.values.created_at}
              onChange={val => formik.setFieldValue('created_at', formatDateTime(val))}
              error={Boolean(formik.errors.created_at)}
            />
          </LocalizationProvider>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Ośrodek</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            select
            name="resort"
            placeholder="ośrodek"
            options={order.resort_event_camp_data.resorts}
            value={formik.values.resort}
            onChange={formik.handleChange}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Termin</Typography>
          <AutocompleteImpl
            sx={{ flex: '1 1 70%' }}
            displayName={order.period_display}
            action={getPeriodsAction}
            fieldName="period"
            formik={formik}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Termin od</Typography>
          <SmallFormDateField
            sx={{ flex: '1 1 70%' }}
            name="period_from"
            id="period_from"
            type="text"
            placeholder="period_from"
            value={formik.values.period_from}
            onChange={val => formik.setFieldValue('period_from', formatDate(val))}
            error={Boolean(formik.errors.period_from)}
            helperText={formik.touched.period_from && formik.errors.period_from}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Termin do</Typography>
          <SmallFormDateField
            sx={{ flex: '1 1 70%' }}
            name="period_to"
            id="period_to"
            type="text"
            placeholder="period_to"
            value={formik.values.period_to}
            onChange={val => formik.setFieldValue('period_to', formatDate(val))}
            error={Boolean(formik.errors.period_to)}
            helperText={formik.touched.period_to && formik.errors.period_to}
          />
        </Stack>
        {seasonYear > 2025 && <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Pakiet</Typography>
          <AutocompleteImpl
            sx={{ flex: '1 1 70%' }}
            displayName={order.package_display}
            action={getPackagesAction}
            fieldName="package"
            formik={formik}
          />
        </Stack>}
        {['l_23_zs', 'l_24_zs'].includes(seasonIdentifier) ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Ilość uczestników w grze paintballowej</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            error={formik.errors.paintball_participants_count && formik.touched.paintball_participants_count}
            name="paintball_participants_count"
            placeholder="ilość uczestników w grze paintballowej"
            value={formik.values.paintball_participants_count}
            onChange={formik.handleChange}
            helperText={formik.errors.paintball_participants_count}
          />
        </Stack>
          : null}
        {['l_25_zs'].includes(seasonIdentifier) ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Ilość uczestników Koszulki Tie Die</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            error={formik.errors.optional_activity_count_1 && formik.touched.optional_activity_count_1}
            name="optional_activity_count_1"
            placeholder="Wpisz ilość uczestników"
            value={formik.values.optional_activity_count_1}
            onChange={formik.handleChange}
            helperText={formik.errors.optional_activity_count_1}
          />
        </Stack>
          : null}
        {['l_25_zs'].includes(seasonIdentifier) ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Ilość uczestników Fabryka mydełek</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            error={formik.errors.optional_activity_count_2 && formik.touched.optional_activity_count_2}
            name="optional_activity_count_2"
            placeholder="Wpisz ilość uczestników"
            value={formik.values.optional_activity_count_2}
            onChange={formik.handleChange}
            helperText={formik.errors.optional_activity_count_2}
          />
        </Stack>
          : null}
        {['l_25_zs'].includes(seasonIdentifier) ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Ilość uczestników Piana Party</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 70%' }}
            error={formik.errors.optional_activity_count_3 && formik.touched.optional_activity_count_3}
            name="optional_activity_count_3"
            placeholder="Wpisz ilość uczestników"
            value={formik.values.optional_activity_count_3}
            onChange={formik.handleChange}
            helperText={formik.errors.optional_activity_count_3}
          />
        </Stack>
          : null}
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
          <Typography variant="subtitle2" flex="1 1 30%">Zajęcia</Typography>
          <AutocompleteImpl
            multiple={true}
            sx={{ flex: '1 1 70%' }}
            defaultValue={order.activities}
            displayName={order.activities}
            action={getActivitiesAction}
            fieldName="activities"
            formik={formik}
            resortId={formik.values.resort}
            disablePortal={false}
          />
        </Stack>
        {seasonYear > 2025 && <DynamicMultiFieldCard
          formik={formik}
          title=""
          fields={[
            {
              label: 'Zajęcia Dodatkowo Płatne',
              field: 'additionally_paid_activities_json',
              keyName: 'Zajęcie',
              secondKeyName: 'Liczba osób',
              options: order.additionally_paid_activities_choices
            }
          ]}
          inline
        />}
      </Stack>
    </Box>
  );
};

export default ZSOrderDetailsForm;
